export const labelColumnClass: string = "col-md-6 col-xl-7";

export const controlColumnClass: string = "col-md-6 col-xl-5";